import {BasePage, page} from "./BasePage";

@page("RoadMap")
export class RoadMap extends BasePage {

	protected get data() {
		return {
			title: "ROADMAP",
			items: [{
				dir: "left",
				name: "Alpha",
				src: require("../../assets/roadmap1.png"),
				desc: `In May, we will drop the genesis PokerDAO Membership NFTs. These NFTs will allow for community access. These will serve as the key to unlock membership
Token Airdrop to NFT holders`
			}, {
				dir: "middle",
				name: "Beta",
				src: require("../../assets/roadmap2.png"),
				desc: `We will launch the PokerDAO game platform. Everyone will have the right to access this platform and use CHIP tokens to play on the platform; however, PokerDAO holders will be able to claim rewards from the pot.`
			}, {
				dir: "right",
				name: "Future",
				src: require("../../assets/roadmap3.png"),
				desc: `The PokerDAO is ever-expanding and new experiences are available to collectors. Collectors can expect exclusive access to the latest products, merchandise and events through ownership.`
			}]
		};
	}

	protected webContent() {
		// 在这里完善内容
		return <div>
			<img className="background" src={require("../../assets/deco2.png")}/>
			<div className="title">{this.data.title}</div>
			<div className="content">
				{this.data.items.map(item =>
					<div className={`item ${item.dir}`}>
						<div className="item-content">
							<div className="image">
								<div className="shine blue-shine"/>
								<img src={item.src}/>
							</div>
							<div className="name">
								<div className="dot"/> {item.name}
							</div>
							<div className="desc">{item.desc}</div>
						</div>
					</div>
				)}
			</div>
		</div>
	}

	protected mobileContent(): JSX.Element {
		return <div>
			<img className="background" src={require("../../assets/deco2.png")}/>
			<div className="title">{this.data.title}</div>
			<div className="content">
				{this.data.items.map((item, i) =>
					<div className={`item ${item.dir}`}>
						<div className="item-content">
							<div className="image">
								{i == 0 && <div className="shine blue-shine"/>}
								<img src={item.src}/>
							</div>
							<div className="name">
								<div className="dot"/>
								{item.name}
							</div>
							<div className="desc">{item.desc}</div>
						</div>
					</div>
				)}
			</div>
		</div>
	}
}
